import "../css/scss/style.scss";
import "../css/scss/modules.scss";
import "../css/app.css";

// import { __ } from "@wordpress/i18n";

const { __, _n } = wp.i18n;
import Swiper, { Pagination, Navigation, Lazy } from "swiper";
import SnapSlider from "./modules/slider";
import BurgerPlugin from "./modules/burger";
import "lazysizes";
import { Timer } from "easytimer.js";
import MicroModal from "micromodal";
// import isEmail from "validator/lib/isEmail";
import isMobilePhone from "validator/lib/isMobilePhone";
import IMask from "imask";

MicroModal.init();

document
	.querySelectorAll("input[data-input-bid], input[data-input-price]")
	?.forEach((el) => {
		IMask(el, {
			mask: [
				{ mask: "" },
				{
					mask: "num $",
					lazy: false,
					blocks: {
						num: {
							mask: Number,
							max: 10000000,
							min: el.dataset.min ? +el.dataset.min : 0,
							scale: 0,
							thousandsSeparator: " ",
							padFractionalZeros: true,
							mapToRadix: [" "],
						},
					},
				},
			],
		});
	});

document.querySelectorAll('input[name="tel"]')?.forEach((el) => {
	IMask(el, {
		mask: [
			{
				mask: "+{380} 00 00 00 000",
			},
			{
				mask: "000 00 00 000",
				startsWith: "0",
			},
			{
				mask: "0000000000000",
			},
		],
	});
	el.addEventListener("input", () => {
		el.setCustomValidity("");
		el.checkValidity();
	});
});

document.querySelectorAll('input[name="name"]')?.forEach((el) => {
	IMask(el, {
		mask: [
			{
				mask: /^[а-яА-ЯёЁіІїЇa-zA-Z\s]+$/,
			},
		],
	});
});

if (document.getElementById("deadline")) {
	const timer = new Timer();

	document.getElementById("sec").style.width =
		document.getElementById("sec").offsetWidth + "px";

	timer.start({
		countdown: true,
		startValues: JSON.parse(
			document.getElementById("deadline").dataset.startValues
		),
	});

	timer.addEventListener("secondsUpdated", function (e) {
		const timeValues = timer.getTimeValues();
		document.getElementById("days").innerHTML = timeValues.days;
		document.getElementById("hours").innerHTML = timeValues.hours;
		document.getElementById("minutes").innerHTML = timeValues.minutes;
		document.getElementById("seconds").innerHTML = timeValues.seconds;

		document.getElementById("string-days").innerHTML = _n(
			"Day",
			"Days",
			timeValues.days,
			"frontenda-store-front"
		);
		document.getElementById("string-hours").innerHTML = _n(
			"Hour",
			"Hours",
			timeValues.hours,
			"frontenda-store-front"
		);
		document.getElementById("string-minutes").innerHTML = _n(
			"Minute",
			"Minutes",
			timeValues.minutes,
			"frontenda-store-front"
		);
		document.getElementById("string-seconds").innerHTML = _n(
			"Second",
			"Seconds",
			timeValues.seconds,
			"frontenda-store-front"
		);
	});

	timer.addEventListener("targetAchieved", function (e) {
		document.querySelector("[data-countdown]").style.display = "none";
		document.querySelector("[data-countdow-achieved]").style.display = "block";
	});
}

// import ShowMorePlugin from "./modules/show-more-plugin";

import { toggleLoader } from "./modules/functions";

import setScrollBarWidth from "set-scrollbar-width";

// import "@iconfu/svg-inject";

setScrollBarWidth();

function initSlider(el, options) {
	if (window.innerWidth > 1024) {
		return new SnapSlider(el, options);
	}
}

document.querySelectorAll("span.reload").forEach((el) => {
	el.addEventListener("click", () => {
		location.reload();
	});
});

window.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".slider-container")?.forEach((el) => {
		let options = {
			observer: true,
			autoscroll: true,
			infinity: true,
			prev: el.querySelector(".slider-prev"),
			next: el.querySelector(".slider-next"),
		};
		let slider;
		// Initialize the slider on page load
		slider = initSlider(el.querySelector(".slider-list"), options);

		// Listen for the `resize` event and reinitialize the slider as needed
		window.addEventListener("resize", () => {
			if (window.innerWidth >= 1024 && !slider) {
				slider = initSlider(el.querySelector(".slider-list"), options);
			} else if (window.innerWidth < 1024 && slider) {
				slider.destroy();
				slider = null;
			}
		});
	});

	document.querySelectorAll(".swiper-container").forEach((el, index) => {
		let swiper = new Swiper(el, {
			modules: [Lazy, Navigation],
			// Navigation arrows
			navigation: {
				nextEl: ".swiper-button-next_" + index,
				prevEl: ".swiper-button-prev_" + index,
			},
			slidesPerView: 1,
			lazy: true,
			spaceBetween: 26,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},
		});
	});

	document.querySelectorAll("[data-btn-open-modal-form]")?.forEach((el) =>
		el.addEventListener("click", () => {
			openModalWithData(el);
		})
	);
});

// Використання плагіна
if (document.getElementById("burger")) {
	const burgerPlugin = new BurgerPlugin(
		document.getElementById("burger"),
		document.getElementById("mobile-menu")
	);
}

const swiper = new Swiper("#observer-offer", {
	modules: [Pagination, Navigation],
	// If we need pagination
	pagination: {
		el: ".offer-pagination",
		type: "fraction",
		formatFractionTotal: (number) => (number < 9 ? "0" + number : number),
		formatFractionCurrent: (number) => (number < 9 ? "0" + number : number),
	},
	autoHeight: true,
	// Navigation arrows
	navigation: {
		nextEl: ".offer-next",
		prevEl: ".offer-prev",
	},
	on: {
		init: function () {
			const ford = document.getElementById("ford");
			ford.classList.add("current");
		},
		slideChange: function (swiper) {
			const ford = document.getElementById("ford");
			const bmw = document.getElementById("bmw");
			ford.classList.toggle("current");
			bmw.classList.toggle("current");
		},
	},
});

function openModalWithData(el) {
	const attrs = JSON.parse(el.dataset.btnOpenModalForm);
	const { id, texts, values } = attrs;
	const modalId = `modal-form-${id}`;
	if (texts) {
		for (const key in texts) {
			if (Object.hasOwnProperty.call(texts, key)) {
				const element = texts[key];
				document.getElementById(`${modalId}-${key}`).innerHTML =
					wrapTextInSpan(element);
			}
		}
	}
	if (values) {
		for (const key in values) {
			if (Object.hasOwnProperty.call(values, key)) {
				const element = values[key];
				document.getElementById(`${modalId}-${key}`).value = element;
			}
		}
	}

	// Show Modal
	MicroModal.show(modalId, {
		disableScroll: true,
	});
}

function wrapTextInSpan(text) {
	return text.replace(/\{([^}]+)\}/g, "<span>$1</span>");
}

document.querySelectorAll("[data-form-callback]").forEach((el) => {
	sendFormData(el, theme.api.ajax_url, "contactForm", onSuccess, onError);
});

function sendFormData(el, url, action, successCallback, errorCallback) {
	el.addEventListener("submit", async (e) => {
		e.preventDefault();

		const loadingElement = el.querySelector('[type="submit"]');
		const formData = new FormData(el);

		if (formData.has("tel")) {
			const input = el.querySelector('input[name="tel"]');
			if (!isMobilePhone(formData.get("tel").replaceAll(" ", ""))) {
				input.setCustomValidity(
					__("Не існуючий телефон", "frontenda-store-front")
				);
				input.reportValidity();
				return false;
			}
		}

		formData.append("wpnonce", theme.api.nonce);

		const data = new URLSearchParams(formData);
		const headers = new Headers();
		headers.append("Content-Type", "application/x-www-form-urlencoded");

		toggleLoader(loadingElement);

		let response = await fetch(url + "?action=" + action, {
			method: "POST",
			headers: headers,
			body: data,
		});

		let result = await response.json();
		let closeModal = false;
		document.querySelectorAll(".modal").forEach((el) => {
			if (el.classList.contains("is-open")) {
				closeModal = true;
			}
		});

		if (closeModal) {
			MicroModal.close();
		}

		if (result.success) {
			// localStorage.setItem("formData", data);
			// localStorage.setItem("showCloseContent", true);
			// document.querySelectorAll(".hidden-content")?.forEach((el) => {
			// 	el.remove();
			// });
			if (successCallback) {
				successCallback(formData.get("form"));
			}
		} else {
			if (errorCallback) {
				errorCallback(formData.get("form"));
			}
		}
		toggleLoader(loadingElement);

		el.reset();
	});
}
function onSuccess(formName) {
	MicroModal.show("modal-form-thankyou");
	if (window.fbq) {
		fbq("track", "Lead");
	}
	sendEventDataToGA4("generate_lead", {
		"form_name": formName,
	});
}

function onError(formName) {
	MicroModal.show("modal-form-error");
	sendEventDataToGA4("lead_unsuccess", {
		"form_name": formName,
	});
}

function sendEventDataToGA4(event, data = {}) {
	window.dataLayer = window.dataLayer || [];

	window.dataLayer.push({
		"event": event,
		...data
	});

	// console.log(window.dataLayer);
}